import { render, staticRenderFns } from "./previewTesting.vue?vue&type=template&id=498c12f5&scoped=true&"
import script from "./previewTesting.vue?vue&type=script&lang=js&"
export * from "./previewTesting.vue?vue&type=script&lang=js&"
import style0 from "./previewTesting.vue?vue&type=style&index=0&id=498c12f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c12f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
